import Layout from "./Layout";

interface IProps {
  children?: any;
}
const LayoutContainer = ({ children }: IProps) => {
  return <Layout>{children}</Layout>;
};

export default LayoutContainer;
